import { render, staticRenderFns } from "./JobAccountFormStepPropertyOwnerInformation.vue?vue&type=template&id=4f8e50c2"
import script from "./JobAccountFormStepPropertyOwnerInformation.vue?vue&type=script&lang=js"
export * from "./JobAccountFormStepPropertyOwnerInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports